const AccountDeletionApp = () => {
  return (
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSdv78Sa0loTIqe6nnOWs4TUz15-55LVx6es24mwgkWAVV4AVA/viewform?embedded=true"
      width="100%"
      height="1750"
    >
      Memuat...F
    </iframe>
  )
}

export default AccountDeletionApp
